const es = {
  // ============================================================
  // COMMON — Compartido en toda la aplicación
  // ============================================================
  common: {
    loading: 'Cargando...',
    error: 'Error',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    add: 'Añadir',
    remove: 'Quitar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    apply: 'Aplicar',
    reset: 'Restablecer',
    search: 'Buscar',
    filter: 'Filtrar',
    clear: 'Borrar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    submit: 'Enviar',
    update: 'Actualizar',
    refresh: 'Actualizar',
    export: 'Exportar',
    import: 'Importar',
    download: 'Descargar',
    upload: 'Cargar',
    print: 'Imprimir',
    copy: 'Copiar',
    yes: 'Sí',
    no: 'No',
    ok: 'OK',
    done: 'Hecho',
    select: 'Seleccionar',
    selectAll: 'Seleccionar todo',
    deselectAll: 'Deseleccionar todo',
    noResults: 'No se encontraron resultados',
    noData: 'No hay datos disponibles',
    required: 'Obligatorio',
    optional: 'Opcional',
    actions: 'Acciones',
    details: 'Detalles',
    overview: 'Resumen general',
    summary: 'Resumen',
    total: 'Total',
    all: 'Todos',
    none: 'Ninguno',
    name: 'Nombre',
    type: 'Tipo',
    status: 'Estado',
    date: 'Fecha',
    time: 'Hora',
    description: 'Descripción',
    notes: 'Notas',
    comments: 'Comentarios',
    category: 'Categoría',
    priority: 'Prioridad',
    nation: 'Nación',
    country: 'País',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    location: 'Ubicación',
    coordinates: 'Coordenadas',
    latitude: 'Latitud',
    longitude: 'Longitud',
    from: 'Desde',
    to: 'Hasta',
    createdAt: 'Creado',
    updatedAt: 'Actualizado',
    createdBy: 'Creado por',
    modifiedBy: 'Modificado por',
    active: 'Activo',
    inactive: 'Inactivo',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    showing: 'Mostrando',
    of: 'de',
    page: 'Página',
    perPage: 'por página',
    rows: 'filas',
    items: 'elementos',
    results: 'resultados',
    sortBy: 'Ordenar por',
    ascending: 'Ascendente',
    descending: 'Descendente',
    viewAll: 'Ver todo',
    viewDetails: 'Ver detalles',
    goBack: 'Volver',
    learnMore: 'Más información',
    seeMore: 'Ver más',
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
    expandAll: 'Expandir todo',
    collapseAll: 'Contraer todo',
    copied: '¡Copiado!',
    saved: '¡Guardado!',
    deleted: '¡Eliminado!',
    updated: '¡Actualizado!',
    created: '¡Creado!',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Info',
    danger: 'Peligro',
    unknown: 'Desconocido',
    notAvailable: 'N/D',
    never: 'Nunca',
    today: 'Hoy',
    yesterday: 'Ayer',
    tomorrow: 'Mañana',
    now: 'Ahora',
    ago: 'hace',
    justNow: 'justo ahora',
    minutesAgo: 'hace {{count}} min',
    hoursAgo: 'hace {{count}} h',
    daysAgo: 'hace {{count}} d',
    monthsAgo: 'hace {{count}} meses',
    id: 'ID',
    version: 'Versión',
    language: 'Idioma',
    theme: 'Tema',
    darkMode: 'Modo oscuro',
    lightMode: 'Modo claro',
    failedToLoad: 'Error al cargar los datos',
    failedToSave: 'Error al guardar',
    failedToDelete: 'Error al eliminar',
    failedToUpdate: 'Error al actualizar',
    confirmDelete: '¿Está seguro de que desea eliminar este elemento?',
    confirmAction: '¿Está seguro?',
    unsavedChanges: 'Tiene cambios sin guardar. ¿Está seguro de que desea salir?',
    pageNotFound: '404 - Página no encontrada',
    pageNotFoundDesc: 'La página que busca no existe.',
    backToDashboard: 'Volver al panel',
    characters: 'caracteres',
    maxCharacters: 'Máximo {{max}} caracteres',
    remaining: '{{count}} restantes',
    selected: '{{count}} seleccionados',
    of_total: '{{count}} de {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Encabezado, barra lateral, menús
  // ============================================================
  nav: {
    dashboard: 'Panel',
    requests: 'Solicitudes',
    transports: 'Transportes',
    myPatients: 'Mis pacientes',
    statistics: 'Estadísticas',
    flow: 'Flujo',
    resources: 'Resources',
    exercise: 'Ejercicio',
    administration: 'Administración',
    map: 'Mapa',
    info: 'Info',
    users: 'Usuarios',
    assets: 'Medios de transporte',
    hubs: 'Hubs',
    treatmentFacilities: 'Centros sanitarios',
    patientImport: 'Importación de pacientes',
    assetTemplates: 'Plantillas de medios',
    dayTemplates: 'Plantillas de jornada',
    announcementTicker: 'Barra de anuncios',
    exerciseStatistics: 'Estadísticas del ejercicio',
    settings: 'Configuración',
    auditLog: 'Registro de auditoría',
    exerciseControl: 'Control del ejercicio',
    dataSync: 'Sincronización de datos',
    documentation: 'Documentación',
    support: 'Soporte',
    about: 'Acerca de',
    assetContracts: 'Asset Contracts',
    notifications: 'Notificaciones',
    schedules: 'Horarios',
    capacityPlanning: 'Planificación de capacidad',
    transportPlanning: 'Planificación de transportes',
    transportBooking: 'Reserva de transporte',
    flowDiagram: 'Diagrama de flujo',
    changePassword: 'Cambiar contraseña',
    missions: 'Misiones',
    startPoints: 'Puntos de partida',
    hospital: 'Hospital',
  },

  // ============================================================
  // AUTH — Inicio de sesión, contraseña, sesión
  // ============================================================
  auth: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    logoutNow: 'Cerrar sesión ahora',
    loggingIn: 'Iniciando sesión...',
    loginFailed: 'Error de inicio de sesión',
    email: 'Correo electrónico',
    password: 'Contraseña',
    username: 'Nombre de usuario',
    enterEmail: 'Introduzca su dirección de correo electrónico',
    enterPassword: 'Introduzca su contraseña',
    enterUsername: 'Introduzca su nombre de usuario',
    forgotPassword: '¿Olvidó su contraseña?',
    forgotPasswordTitle: 'Contraseña olvidada',
    forgotPasswordDesc: 'Introduzca su nombre de usuario y su dirección de correo electrónico. Si ambos coinciden, los administradores serán notificados para restablecer su contraseña.',
    requestPasswordReset: 'Solicitar restablecimiento de contraseña',
    sending: 'Enviando...',
    backToLogin: 'Volver al inicio de sesión',
    pleaseWait: 'Espere antes de intentar de nuevo.',
    requestFailed: 'Error en la solicitud',
    credentialsMatch: 'Si las credenciales coinciden, los administradores han sido notificados.',
    forAccess: 'Para obtener acceso, contacte con su administrador del sistema.',
    changePassword: 'Cambiar contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    passwordChanged: 'Contraseña cambiada con éxito',
    passwordMismatch: 'Las contraseñas no coinciden',
    passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
    changingPassword: 'Cambiando...',
    mustChangePassword: 'Debe cambiar su contraseña antes de continuar.',
    sessionExpiring: 'Sesión a punto de expirar',
    sessionExpireText: 'Su sesión expirará en <strong>{{time}}</strong>. Guarde su trabajo e inicie sesión de nuevo para continuar.',
    dismiss: 'Cerrar',
    switchNation: 'Cambiar nación',
    returnTo: 'Volver a {{nation}}',
    viewingAs: 'Está viendo como',
    loggedInAs: 'conectado como {{nation}}',
    trainingMode: 'SOLO PARA FINES DE ENTRENAMIENTO',
    dedication: 'Creado con pasión y dedicación a la profesión',
  },

  // ============================================================
  // ROLES — Roles de usuario y etiquetas
  // ============================================================
  roles: {
    admin: 'Administrador del sistema',
    excon: 'Controlador del ejercicio',
    eu: 'Coordinador UE',
    planner: 'Planificador',
    hub: 'Gestor de hub',
    nation: 'Nación',
    readOnly: 'Solo lectura',
    systemAdmin: 'Administrador del sistema',
    transportPlanner: 'Planificador de transporte',
    systemRoles: 'Roles del sistema',
  },

  // ============================================================
  // STATUS — Estados de solicitudes, ofertas, misiones
  // ============================================================
  status: {
    draft: 'Borrador',
    underReview: 'En revisión',
    published: 'Publicada',
    underSelection: 'En selección',
    accepted: 'Aceptada',
    planned: 'Planificada',
    inTransit: 'En tránsito',
    completed: 'Completada',
    closed: 'Cerrada',
    withdrawn: 'Retirada',
    pending: 'Pendiente',
    rejected: 'Rechazada',
    cancelled: 'Cancelada',
    active: 'Activa',
    inactive: 'Inactiva',
    review: 'Revisión',
    selection: 'Selección',
    transit: 'Tránsito',
  },

  // ============================================================
  // CATEGORIES — Categorías de solicitudes
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personal',
    material: 'Material',
    equipment: 'Equipamiento',
    other: 'Otro',
    news: 'Noticias',
  },

  // ============================================================
  // URGENCY — Niveles de urgencia
  // ============================================================
  urgency: {
    routine: 'Rutinaria',
    priority: 'Prioritaria',
    urgent: 'Urgente',
    immediate: 'Inmediata',
  },

  // ============================================================
  // ASSETS — Tipos de medios de transporte
  // ============================================================
  assetTypes: {
    train: 'Tren',
    ship: 'Barco',
    aircraft: 'Aeronave',
    bus: 'Autobús',
    ambulance: 'Ambulancia',
    drone: 'Dron',
    helicopter: 'Helicóptero',
    ferry: 'Ferri',
    other: 'Otro',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Panel',
    goodMorning: 'Buenos días',
    goodAfternoon: 'Buenas tardes',
    goodEvening: 'Buenas noches',
    lastLogin: 'Último acceso',
    infrastructure: 'Infraestructura',
    transportAssets: 'Medios de transporte',
    treatmentFacilities: 'Centros sanitarios',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Estadísticas de solicitudes',
    viewAllRequests: 'Ver todas las solicitudes',
    availableAssets: 'Medios disponibles',
    seated: 'Sentados',
    lying: 'Acostados',
    intensive: 'Cuidados intensivos',
    notifications: 'Notificaciones',
    markAllRead: 'Marcar todo como leído',
    noNotifications: 'Ninguna notificación por el momento',
    notifiedWhenActivity: 'Se le notificará cuando se produzca nueva actividad',
    viewDetailsBtn: 'Ver detalles',
    nationUsers: 'Usuarios nacionales',
    user: 'Usuario',
    roles: 'Roles',
    noUsersFound: 'No se encontraron usuarios',
    participatingNations: 'Naciones participantes',
    exerciseDisclaimer: 'Este sistema es solo para uso en ejercicios. Introduzca exclusivamente datos simulados del ejercicio. Los flujos de trabajo están adaptados al escenario del ejercicio y pueden diferir de los procedimientos reales. Las normas de seguridad informática y protección de datos siguen siendo plenamente aplicables.',
    notConfigured: 'No configurado',
    requestCount: '{{count}} solicitud(es)',
    clickToView: 'Haga clic para ver',
    systemAdministration: 'Administración del sistema',
    exerciseControlTitle: 'Control del ejercicio',
    euCoordination: 'Coordinación UE',
    transportPlanningTitle: 'Planificación de transportes',
    hubManagement: 'Gestión de hubs',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nueva solicitud',
    myDrafts: 'Mis borradores',
    pendingReview: 'Pendientes de revisión',
    activeTransports: 'Transportes activos',
    myPatients: 'Mis pacientes',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Solicitudes',
    newRequest: 'Nueva solicitud',
    createRequest: 'Crear solicitud',
    editRequest: 'Editar solicitud',
    requestDetail: 'Detalle de la solicitud',
    requestId: 'ID de la solicitud',
    fromNation: 'De la nación',
    toNation: 'A la nación',
    requestingNation: 'Nación solicitante',
    receivingNation: 'Nación receptora',
    category: 'Categoría',
    urgency: 'Urgencia',
    status: 'Estado',
    patients: 'Pacientes',
    patientCount: 'Número de pacientes',
    offers: 'Ofertas',
    offerCount: 'Número de ofertas',
    created: 'Creada',
    updated: 'Actualizada',
    submittedBy: 'Enviada por',
    reviewedBy: 'Revisada por',
    description: 'Descripción',
    medicalDetails: 'Detalles médicos',
    transportDetails: 'Detalles del transporte',
    additionalInfo: 'Información adicional',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Punto de partida',
    arrivalPoint: 'Punto de llegada',
    estimatedDeparture: 'Salida estimada',
    estimatedArrival: 'Llegada estimada',
    submitForReview: 'Enviar para revisión',
    publish: 'Publicar',
    startSelection: 'Iniciar la selección',
    acceptOffer: 'Aceptar la oferta',
    markInTransit: 'Marcar como en tránsito',
    markCompleted: 'Marcar como completada',
    closeRequest: 'Cerrar la solicitud',
    withdrawRequest: 'Retirar la solicitud',
    withdraw: 'Retirar',
    revertToDraft: 'Devolver a borrador',
    deleteRequest: 'Eliminar la solicitud',
    duplicateRequest: 'Duplicar la solicitud',
    createFollowUp: 'Crear solicitud consolidada',
    followUpRequest: 'Solicitud consolidada',
    parentRequest: 'Solicitud original',
    childRequests: 'Solicitudes consolidadas',
    noRequests: 'No se encontraron solicitudes',
    noOffers: 'Ninguna oferta por el momento',
    addPatient: 'Añadir paciente',
    removePatient: 'Quitar paciente',
    patientDetails: 'Detalles del paciente',
    contactPerson: 'Persona de contacto',
    contactPhone: 'Teléfono de contacto',
    contactEmail: 'Correo de contacto',
    specialRequirements: 'Requisitos especiales',
    medicalEquipment: 'Equipamiento médico',
    accompaniment: 'Acompañamiento',
    timeline: 'Cronología',
    history: 'Historial',
    addComment: 'Añadir comentario',
    writeComment: 'Escribir un comentario...',
    postComment: 'Publicar comentario',
    posting: 'Publicando...',
    noComments: 'Ningún comentario por el momento',
    coverageBar: 'Cobertura',
    covered: 'cubiertos',
    uncovered: 'sin cubrir',
    filterByStatus: 'Filtrar por estado',
    filterByCategory: 'Filtrar por categoría',
    filterByNation: 'Filtrar por nación',
    searchRequests: 'Buscar solicitudes...',
    confirmWithdraw: '¿Está seguro de que desea retirar esta solicitud?',
    confirmDelete: '¿Está seguro de que desea eliminar esta solicitud?',
    confirmPublish: '¿Está seguro de que desea publicar esta solicitud? Será visible para todas las naciones.',
    confirmStartSelection: '¿Está seguro de que desea iniciar la selección? Las naciones podrán presentar ofertas.',
    warningStartSelection: 'Iniciar la selección hará que esta solicitud sea visible para todas las naciones participantes. Podrán presentar ofertas para los pacientes de esta solicitud. Esta acción no se puede deshacer.',
    warningMakeOffer: 'Al enviar esta oferta, su nación se compromete a proporcionar la asistencia propuesta. Esta acción notificará a la nación solicitante y al control del ejercicio.',
    saveDraft: 'Guardar borrador',
    saving: 'Guardando...',
    saveAndSubmit: 'Guardar y enviar',
    step: 'Paso {{number}}',
    generalInfo: 'Información general',
    patientInfo: 'Información del paciente',
    logisticsInfo: 'Información logística',
    reviewSubmit: 'Revisión y envío',
    requestTitle: 'Título de la solicitud',
    requestDescription: 'Descripción de la solicitud',
    numberOfPatients: 'Número de pacientes',
    typeOfAssistance: 'Tipo de asistencia',
    medicalTreatment: 'Tratamiento médico',
    transportAssistance: 'Asistencia de transporte',
    both: 'Ambos',
    treatmentOnly: 'Solo tratamiento',
    transportOnly: 'Solo transporte',
    validationErrors: 'Corrija los siguientes errores:',
    fieldRequired: 'Este campo es obligatorio',
    selectExitHub: 'Seleccione un hub de salida',
    createExitHub: 'Crear hub de salida',
    backToRequests: 'Volver a solicitudes',
    noRequestsFound: 'No se encontraron solicitudes',
    createFirstRequest: 'Cree su primera solicitud para comenzar',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Ofertas',
    createOffer: 'Crear oferta',
    makeOffer: 'Presentar oferta',
    manageOffers: 'Gestionar ofertas',
    offerDetail: 'Detalle de la oferta',
    offerId: 'ID de la oferta',
    offeringNation: 'Nación oferente',
    offerType: 'Tipo de oferta',
    treatment: 'Tratamiento',
    transport: 'Transporte',
    combined: 'Combinada',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Oferta de tratamiento',
    transportOffer: 'Oferta de transporte',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Seleccionar pacientes',
    selectedPatients: 'Pacientes seleccionados',
    patientSelection: 'Selección de pacientes',
    offerConfiguration: 'Configuración de la oferta',
    reviewOffer: 'Revisar oferta',
    submitOffer: 'Enviar oferta',
    submitting: 'Enviando...',
    acceptOffer: 'Aceptar oferta',
    rejectOffer: 'Rechazar oferta',
    withdrawOffer: 'Retirar oferta',
    noOffers: 'No hay ofertas disponibles',
    noOffer: 'No Offer',
    offerStatus: 'Estado de la oferta',
    offerDate: 'Fecha de la oferta',
    transportAsset: 'Medio de transporte',
    departureDate: 'Fecha de salida',
    arrivalDate: 'Fecha de llegada',
    treatmentFacility: 'Centro sanitario',
    capacity: 'Capacidad',
    availableCapacity: 'Capacidad disponible',
    totalCapacity: 'Capacidad total',
    selectAsset: 'Seleccionar medio',
    selectFacility: 'Seleccionar centro',
    offerNotes: 'Notas de la oferta',
    confirmAccept: '¿Está seguro de que desea aceptar esta oferta?',
    confirmReject: '¿Está seguro de que desea rechazar esta oferta?',
    extendTransport: 'Extender transporte',
    transportExtension: 'Extensión del transporte',
    comparisonView: 'Vista comparativa',
    shortlist: 'Lista reducida',
    addToShortlist: 'Añadir a la lista reducida',
    removeFromShortlist: 'Quitar de la lista reducida',
    leaveConfirmTitle: '¿Salir de esta página?',
    leaveConfirmMessage: 'Tiene cambios sin guardar. ¿Está seguro de que desea salir?',
    stayOnPage: 'Permanecer en la página',
    leavePage: 'Salir de la página',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transportes',
    missionDetail: 'Detalle del transporte',
    missionId: 'ID del transporte',
    missionStatus: 'Estado del transporte',
    createMission: 'Crear transporte',
    overview: 'Resumen general',
    patientsTab: 'Pacientes',
    transportsTab: 'Tramos de transporte',
    treatmentTab: 'Tratamiento',
    reviewTab: 'Revisión',
    departure: 'Salida',
    arrival: 'Llegada',
    origin: 'Origen',
    destination: 'Destino',
    stops: 'Paradas',
    addStop: 'Añadir parada',
    removeStop: 'Quitar parada',
    stopName: 'Nombre de la parada',
    stopType: 'Tipo de parada',
    estimatedTime: 'Hora estimada',
    actualTime: 'Hora real',
    asset: 'Medio',
    driver: 'Conductor',
    crew: 'Tripulación',
    noMissions: 'No se encontraron transportes',
    completeMission: 'Completar transporte',
    cancelMission: 'Cancelar transporte',
    startTransport: 'Iniciar transporte',
    missionChain: 'Cadena de transporte',
    linkedMissions: 'Transportes vinculados',
    handover: 'Transferencia',
    handoverPoint: 'Punto de transferencia',
    pickupPoint: 'Punto de recogida',
    dropoffPoint: 'Punto de entrega',
    searchTransports: 'Buscar transportes...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacientes',
    myPatients: 'Mis pacientes',
    patientId: 'ID del paciente',
    firstName: 'Nombre',
    lastName: 'Apellido',
    dateOfBirth: 'Fecha de nacimiento',
    age: 'Edad',
    gender: 'Sexo',
    male: 'Masculino',
    female: 'Femenino',
    other: 'Otro',
    nationality: 'Nacionalidad',
    diagnosis: 'Diagnóstico',
    condition: 'Estado',
    stable: 'Estable',
    critical: 'Crítico',
    serious: 'Grave',
    treatmentNeeded: 'Tratamiento necesario',
    allergies: 'Alergias',
    medications: 'Medicamentos',
    bloodType: 'Grupo sanguíneo',
    weight: 'Peso (kg)',
    infectious: 'Infeccioso',
    mentalHealth: 'Salud mental',
    mobility: 'Movilidad',
    ambulatory: 'Ambulatorio',
    wheelchair: 'Silla de ruedas',
    stretcher: 'Camilla',
    intensive: 'Cuidados intensivos',
    oxygenRequired: 'Oxígeno necesario',
    ventilator: 'Ventilador',
    medicalEscort: 'Escolta médica',
    noPatients: 'No se encontraron pacientes',
    patientDetails: 'Detalles del paciente',
    medicalHistory: 'Historial médico',
    travelDocuments: 'Documentos de viaje',
    passport: 'Pasaporte',
    pseudonymizedId: 'ID seudonimizado',
    sensitiveData: 'Datos sensibles',
    journey: 'Recorrido del paciente',
    assignedTo: 'Asignado a',
    currentLocation: 'Ubicación actual',
    importPatients: 'Importar pacientes',
    exportPatients: 'Exportar pacientes',
    seated: 'Sentado',
    lying: 'Acostado',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Usuarios',
    createUser: 'Crear usuario',
    editUser: 'Editar usuario',
    deleteUser: 'Eliminar usuario',
    username: 'Nombre de usuario',
    displayName: 'Nombre para mostrar',
    email: 'Correo electrónico',
    password: 'Contraseña',
    role: 'Rol',
    roles: 'Roles',
    nation: 'Nación',
    active: 'Activo',
    lastLogin: 'Último acceso',
    createdAt: 'Creado',
    isNation: 'Nación',
    isEU: 'UE',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planificador',
    isHub: 'Hub',
    isReadOnly: 'Solo lectura',
    noUsers: 'No se encontraron usuarios',
    confirmDelete: '¿Está seguro de que desea eliminar este usuario?',
    resetPassword: 'Restablecer contraseña',
    generatePassword: 'Generar contraseña',
    searchUsers: 'Buscar usuarios...',
    userCreated: 'Usuario creado con éxito',
    userUpdated: 'Usuario actualizado con éxito',
    userDeleted: 'Usuario eliminado con éxito',
    selectNation: 'Seleccione una nación',
    mustChangePassword: 'Debe cambiar la contraseña en el próximo inicio de sesión',
    flagImage: 'Imagen de la bandera',
    exportUsers: 'Exportar usuarios',
    importUsers: 'Importar usuarios',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Medios de transporte',
    createAsset: 'Crear medio',
    editAsset: 'Editar medio',
    deleteAsset: 'Eliminar medio',
    assetName: 'Nombre del medio',
    assetType: 'Tipo de medio',
    capacitySeated: 'Capacidad (sentados)',
    capacityLying: 'Capacidad (acostados)',
    capacityIntensive: 'Capacidad (cuidados intensivos)',
    owner: 'Propietario',
    operator: 'Operador',
    baseLocation: 'Ubicación base',
    range: 'Autonomía',
    speed: 'Velocidad',
    noAssets: 'No se encontraron medios',
    confirmDelete: '¿Está seguro de que desea eliminar este medio?',
    searchAssets: 'Buscar medios...',
    assetCreated: 'Medio creado con éxito',
    assetUpdated: 'Medio actualizado con éxito',
    assetDeleted: 'Medio eliminado con éxito',
    exportAssets: 'Exportar medios',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Hubs',
    startPoints: 'Puntos de partida',
    createHub: 'Crear hub',
    editHub: 'Editar hub',
    deleteHub: 'Eliminar hub',
    hubName: 'Nombre del hub',
    hubType: 'Tipo de hub',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Hub de entrada',
    airport: 'Aeropuerto',
    seaport: 'Puerto marítimo',
    railStation: 'Estación ferroviaria',
    roadPoint: 'Punto viario',
    ucpmClassification: 'Clasificación UCPM',
    icaoCode: 'Código ICAO',
    iataCode: 'Código IATA',
    noHubs: 'No se encontraron hubs',
    confirmDelete: '¿Está seguro de que desea eliminar este hub?',
    searchHubs: 'Buscar hubs...',
    nationAssignment: 'Asignación de naciones',
    assignNations: 'Asignar naciones',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Centros sanitarios',
    createFacility: 'Crear centro',
    editFacility: 'Editar centro',
    deleteFacility: 'Eliminar centro',
    facilityName: 'Nombre del centro',
    facilityType: 'Tipo de centro',
    hospitalName: 'Nombre del hospital',
    bedCapacity: 'Capacidad de camas',
    specialties: 'Especialidades',
    availableBeds: 'Camas disponibles',
    totalBeds: 'Camas totales',
    contactPerson: 'Persona de contacto',
    noFacilities: 'No se encontraron centros sanitarios',
    confirmDelete: '¿Está seguro de que desea eliminar este centro?',
    searchFacilities: 'Buscar centros...',
    hubNationAssignment: 'Asignación hub-nación',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Horarios',
    createSchedule: 'Crear horario',
    editSchedule: 'Editar horario',
    deleteSchedule: 'Eliminar horario',
    scheduleName: 'Nombre del horario',
    scheduleType: 'Tipo de horario',
    recurring: 'Recurrente',
    oneTime: 'Puntual',
    frequency: 'Frecuencia',
    daily: 'Diaria',
    weekly: 'Semanal',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    departureTime: 'Hora de salida',
    arrivalTime: 'Hora de llegada',
    stops: 'Paradas',
    addStop: 'Añadir parada',
    noSchedules: 'No se encontraron horarios',
    bookings: 'Reservas',
    timeline: 'Cronología',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notificaciones',
    markAllRead: 'Marcar todo como leído',
    markAsRead: 'Marcar como leído',
    markAsUnread: 'Marcar como no leído',
    noNotifications: 'Sin notificaciones',
    viewAll: 'Ver todas las notificaciones',
    settings: 'Configuración de notificaciones',
    emailNotifications: 'Notificaciones por correo',
    inAppNotifications: 'Notificaciones en la aplicación',
    notifyOn: 'Notificarme sobre',
    requestCreated: 'Nueva solicitud',
    requestPublished: 'Solicitud publicada',
    requestClosed: 'Solicitud cerrada',
    requestCompleted: 'Solicitud completada',
    commentAdded: 'Nuevo comentario',
    offerReceived: 'Oferta recibida',
    offerAccepted: 'Oferta aceptada',
    statusChanged: 'Estado modificado',
    selectionStarted: 'Selección iniciada',
    missionCreated: 'Transporte creado',
    missionStatusUpdated: 'Transporte actualizado',
    transportPartnerNamed: 'Socio de transporte',
    transportExtensionReceived: 'Extensión del transporte',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Configuración',
    general: 'General',
    system: 'Sistema',
    email: 'Correo electrónico',
    sync: 'Sincronización',
    security: 'Seguridad',
    appearance: 'Apariencia',
    systemName: 'Nombre del sistema',
    systemEmail: 'Correo del sistema',
    maintenanceMode: 'Modo mantenimiento',
    readOnlyMode: 'Modo solo lectura',
    emailEnabled: 'Correo habilitado',
    smtpHost: 'Host SMTP',
    smtpPort: 'Puerto SMTP',
    smtpUser: 'Usuario SMTP',
    smtpPassword: 'Contraseña SMTP',
    senderEmail: 'Correo del remitente',
    senderName: 'Nombre del remitente',
    testEmail: 'Enviar correo de prueba',
    syncEnabled: 'Sincronización habilitada',
    syncUrl: 'URL de sincronización',
    syncApiKey: 'Clave API de sincronización',
    settingsSaved: 'Configuración guardada con éxito',
    helpdesk: 'Soporte técnico',
    helpdeskTitle: 'Título del soporte técnico',
    helpdeskEmail: 'Correo del soporte técnico',
    helpdeskPhone: 'Teléfono del soporte técnico',
    helpdeskInfo: 'Información del soporte técnico',
    realLifeSupport: 'Soporte en situación real',
    trainingMode: 'Modo entrenamiento',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Registro de auditoría',
    action: 'Acción',
    user: 'Usuario',
    target: 'Objetivo',
    details: 'Detalles',
    timestamp: 'Marca de tiempo',
    ipAddress: 'Dirección IP',
    noLogs: 'No se encontraron registros de auditoría',
    searchLogs: 'Buscar en registros...',
    filterByAction: 'Filtrar por acción',
    filterByUser: 'Filtrar por usuario',
    exportLogs: 'Exportar registros',
    exportCsv: 'Exportar CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Control del ejercicio',
    currentDay: 'Día actual',
    exerciseDay: 'Día de ejercicio',
    nextDay: 'Día siguiente',
    previousDay: 'Día anterior',
    resetExercise: 'Restablecer el ejercicio',
    startExercise: 'Iniciar el ejercicio',
    endExercise: 'Finalizar el ejercicio',
    dayReset: 'Restablecimiento del día',
    confirmReset: '¿Está seguro de que desea restablecer el día de ejercicio? Se eliminarán todos los datos del día actual.',
    resetInProgress: 'Restablecimiento en curso...',
    maintenanceMode: 'Modo mantenimiento',
    enableMaintenance: 'Activar mantenimiento',
    disableMaintenance: 'Desactivar mantenimiento',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sincronización de datos',
    syncStatus: 'Estado de la sincronización',
    lastSync: 'Última sincronización',
    pendingItems: 'Elementos pendientes',
    syncNow: 'Sincronizar ahora',
    syncing: 'Sincronizando...',
    syncSuccess: 'Sincronización completada con éxito',
    syncFailed: 'Error en la sincronización',
    outbox: 'Bandeja de salida',
    inbox: 'Bandeja de entrada',
    configuration: 'Configuración',
    targetUrl: 'URL de destino',
    apiKey: 'Clave API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Mapa',
    layers: 'Capas',
    requests: 'Solicitudes',
    hubs: 'Hubs',
    facilities: 'Centros',
    routes: 'Rutas',
    showAll: 'Mostrar todo',
    hideAll: 'Ocultar todo',
    zoomIn: 'Ampliar',
    zoomOut: 'Reducir',
    resetView: 'Restablecer vista',
    satellite: 'Satélite',
    terrain: 'Terreno',
    offline: 'Sin conexión',
    online: 'En línea',
    tilesOffline: 'Las teselas del mapa se sirven localmente',
    tilesOnline: 'Las teselas del mapa se cargan desde servidores en línea',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Estadísticas',
    overview: 'Resumen general',
    requestsByStatus: 'Solicitudes por estado',
    requestsByCategory: 'Solicitudes por categoría',
    requestsByNation: 'Solicitudes por nación',
    offersByStatus: 'Ofertas por estado',
    patientsByCondition: 'Pacientes por estado',
    transportsByStatus: 'Transportes por estado',
    timeline: 'Cronología',
    totalRequests: 'Total de solicitudes',
    totalOffers: 'Total de ofertas',
    totalPatients: 'Total de pacientes',
    totalTransports: 'Total de transportes',
    averageResponseTime: 'Tiempo medio de respuesta',
    completionRate: 'Tasa de finalización',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Estadísticas del ejercicio',
    overview: 'Resumen general',
    byCategory: 'Por categoría',
    byNation: 'Por nación',
    byDay: 'Por día',
    totalPatientsMoved: 'Total de pacientes trasladados',
    totalRequestsProcessed: 'Total de solicitudes procesadas',
    averageProcessingTime: 'Tiempo medio de procesamiento',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagrama de flujo',
    sankey: 'Sankey',
    nodeGraph: 'Grafo de nodos',
    refresh: 'Actualizar',
    noData: 'No hay datos de flujo disponibles',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Acerca de',
    version: 'Versión',
    systemInfo: 'Información del sistema',
    buildDate: 'Fecha de compilación',
    environment: 'Entorno',
    description: 'ARCOS — Sistema avanzado de comunicación de solicitudes',
    subtitle: 'Asistencia a víctimas y operaciones médicas',
    whatIsArcos: '¿Qué es ARCOS? – Explicación para los participantes del ejercicio',
    arcosDesc1: 'ARCOS es una herramienta digital utilizada en este ejercicio para apoyar y estructurar la comunicación internacional, las solicitudes y los procesos de coordinación entre los actores participantes.',
    arcosDesc2: 'ARCOS proporciona una representación simplificada y orientada al ejercicio de los principios básicos detrás de estos sistemas.',
    arcosUsedFor: 'Durante el ejercicio, ARCOS se utiliza para representar procesos típicos como:',
    arcosUsedForItem1: 'presentación y gestión de solicitudes de asistencia,',
    arcosUsedForItem2: 'coordinación y respuesta a ofertas de apoyo de otras naciones,',
    arcosUsedForItem3: 'seguimiento del estado y progreso de las solicitudes,',
    arcosUsedForItem4: 'y representación simplificada de flujos de transporte o evacuación.',
    arcosDesc3: 'Los flujos de trabajo en ARCOS están intencionadamente simplificados y adaptados a los objetivos de formación específicos del ejercicio.',
    arcosDesc4: 'El objetivo de ARCOS no es simular un sistema real perfecto o completo.',
    arcosDesc5: 'Si ciertos elementos difieren de los procedimientos reales que usted conoce, esto es esperado.',
    facilitatedBy: 'Facilitado por MMCC-E',
    dhcInitiative: 'El Digital Health Corner (DHC) es una iniciativa conjunta de:',
    dhcAuthor1: 'Sven Giegerich — Fuerzas Armadas Alemanas',
    dhcAuthor2: 'Mohamad Haji — Defensa Belga',
    dhcConviction: 'Nacida de la convicción de que la innovación prospera donde la pasión encuentra el pragmatismo.',
    dhcInspired: 'Inspirados por la chispa inicial del MMCC-E, nos propusimos crear soluciones simples pero efectivas.',
    dhcLove: 'Lo hacemos porque amamos nuestro trabajo y creemos que las ideas digitales pueden transformar la colaboración en salud militar.',
    dhcOpen: 'El DHC es una plataforma abierta: libre de jerarquías, abierta a ideas, impulsada por la curiosidad.',
    dhcClosing: 'Digital Health Corner – donde la curiosidad se encuentra con la colaboración.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Documentación',
    gettingStarted: 'Primeros pasos',
    userGuide: 'Guía del usuario',
    faq: 'FAQ',
    troubleshooting: 'Resolución de problemas',
    apiReference: 'Referencia API',
    downloadTemplate: 'Descargar plantilla',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Importación de pacientes',
    uploadFile: 'Cargar archivo',
    selectFile: 'Seleccionar archivo',
    preview: 'Vista previa',
    importNow: 'Importar ahora',
    importing: 'Importando...',
    importSuccess: '{{count}} pacientes importados con éxito',
    importFailed: 'Error en la importación',
    downloadTemplate: 'Descargar plantilla',
    dragDrop: 'Arrastre un archivo aquí, o haga clic para seleccionar',
    supportedFormats: 'Formatos admitidos: XLSX, XLS, CSV',
    rowsFound: '{{count}} filas encontradas',
    validRows: '{{count}} filas válidas',
    invalidRows: '{{count}} filas no válidas',
    duplicateRows: '{{count}} filas duplicadas',
    previewData: 'Vista previa de datos',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Planificación de transportes',
    planRoute: 'Planificar ruta',
    routeBuilder: 'Constructor de rutas',
    addWaypoint: 'Añadir punto de paso',
    removeWaypoint: 'Quitar punto de paso',
    estimatedDuration: 'Duración estimada',
    distance: 'Distancia',
    selectVehicle: 'Seleccionar vehículo',
  },

  transportBooking: {
    title: 'Reserva de transporte',
    bookTransport: 'Reservar transporte',
    availableSlots: 'Plazas disponibles',
    bookingConfirmed: 'Reserva confirmada',
    cancelBooking: 'Cancelar reserva',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Planificación de capacidad',
    totalCapacity: 'Capacidad total',
    usedCapacity: 'Capacidad utilizada',
    availableCapacity: 'Capacidad disponible',
    utilizationRate: 'Tasa de utilización',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Plantillas de medios',
    dayTemplates: 'Plantillas de jornada',
    createTemplate: 'Crear plantilla',
    editTemplate: 'Editar plantilla',
    deleteTemplate: 'Eliminar plantilla',
    templateName: 'Nombre de la plantilla',
    applyTemplate: 'Aplicar plantilla',
    noTemplates: 'No se encontraron plantillas',
    confirmDelete: '¿Está seguro de que desea eliminar esta plantilla?',
    confirmApply: '¿Está seguro de que desea aplicar esta plantilla? Se sobrescribirán los datos existentes.',
    exportTemplates: 'Exportar plantillas',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Barra de anuncios',
    createAnnouncement: 'Crear anuncio',
    editAnnouncement: 'Editar anuncio',
    deleteAnnouncement: 'Eliminar anuncio',
    message: 'Mensaje',
    startTime: 'Hora de inicio',
    endTime: 'Hora de fin',
    active: 'Activo',
    noAnnouncements: 'Sin anuncios',
    confirmDelete: '¿Está seguro de que desea eliminar este anuncio?',
  },

  // ============================================================
  // COMPONENTS — Cadenas de componentes reutilizables
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Buscar...',
      noResults: 'No se encontraron resultados',
      showing: 'Mostrando {{from}} a {{to}} de {{total}}',
      rowsPerPage: 'Filas por página',
      previousPage: 'Página anterior',
      nextPage: 'Página siguiente',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Cambios sin guardar',
      message: 'Tiene cambios sin guardar. ¿Está seguro de que desea salir de esta página?',
      stay: 'Permanecer en la página',
      leave: 'Salir de la página',
    },
    // EmptyState
    emptyState: {
      noData: 'No hay datos disponibles',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Se ha producido un error',
      message: 'Se ha producido un error inesperado. Intente actualizar la página.',
      retry: 'Reintentar',
    },
    // ExportButton
    exportButton: {
      export: 'Exportar',
      exporting: 'Exportando...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Imprimir',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Borrador',
      review: 'Revisión',
      published: 'Publicada',
      selection: 'Selección',
      inTransit: 'En tránsito',
      completed: 'Completada',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Instancia en línea',
      message: 'Modo solo lectura. Los datos se sincronizan desde el servidor principal.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Está viendo como',
      loggedInAs: 'conectado como {{nation}}',
      returnTo: 'Volver a {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Buscar páginas, solicitudes, transportes...',
      searching: 'Buscando...',
      noResults: 'Sin resultados para "{{query}}"',
      navigate: 'Navegar',
      select: 'Seleccionar',
      close: 'Cerrar',
      pages: {
        dashboard: 'Panel',
        requests: 'Solicitudes',
        transports: 'Transportes',
        map: 'Mapa',
        myPatients: 'Mis pacientes',
        flowDiagram: 'Diagrama de flujo',
        statistics: 'Estadísticas',
        assets: 'Medios de transporte',
        startPoints: 'Puntos de partida / Hubs',
        treatmentFacilities: 'Centros sanitarios',
        users: 'Usuarios',
        settings: 'Configuración',
        auditLogs: 'Registro de auditoría',
        exerciseControl: 'Control del ejercicio',
        dataSync: 'Sincronización de datos',
        patientImport: 'Importación de pacientes',
        notifications: 'Notificaciones',
        documentation: 'Documentación',
      },
      actions: {
        importPatientsJson: 'Importar Pacientes (JSON)',
        importPatientsExcel: 'Importar Pacientes (Excel)',
        importUsers: 'Importar Usuarios (Excel)',
        importAssetTemplates: 'Importar Plantillas de Activos (Excel)',
        importDayTemplates: 'Importar Entradas de Plantilla Diaria (Excel)',
        exportRequests: 'Exportar Solicitudes (Excel)',
        exportPatients: 'Exportar Pacientes (Excel)',
        exportUsers: 'Exportar Usuarios (Excel)',
        exportCredentials: 'Exportar Credenciales (PDF)',
        exportAuditExcel: 'Exportar Registros de auditoría (Excel)',
        exportAuditPdf: 'Exportar Registros de auditoría (PDF)',
        pagePatientImport: 'Página de importación de pacientes',
        pageRequestDetail: 'Página de detalle de solicitud',
        pageUsers: 'Página de gestión de usuarios',
        pageAssetTemplates: 'Página de plantillas de activos',
        pageDayTemplates: 'Página de plantillas diarias',
        pageRequests: 'Página de lista de solicitudes',
        pageAuditLogs: 'Página de registros de auditoría',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sesión a punto de expirar',
      message: 'Su sesión expirará en <strong>{{time}}</strong>. Guarde su trabajo e inicie sesión de nuevo para continuar.',
      dismiss: 'Cerrar',
      logoutNow: 'Cerrar sesión ahora',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Seleccione 4 zonas horarias',
      configure: 'Configurar zonas horarias',
      reset: 'Restablecer',
      apply: 'Aplicar',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Seleccionar ubicación',
      latitude: 'Latitud',
      longitude: 'Longitud',
      clickToSelect: 'Haga clic en el mapa para seleccionar una ubicación',
    },
    // Modal
    modal: {
      close: 'Cerrar',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Inicio',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Mantenimiento del sistema',
    message: 'El sistema se está restableciendo para el próximo día de ejercicio. Espere a que finalice el proceso.',
    autoRefresh: 'Esta página se actualizará automáticamente cuando el sistema vuelva a estar disponible.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Al menos 10 caracteres',
    uppercase: '1 letra mayúscula',
    lowercase: '1 letra minúscula',
    digit: '1 dígito',
    special: '1 carácter especial',
  },
};

export default es;
